module.exports = __webpack_public_path__ + "img/bookmark.0dd0ba8d.svg";